'use strict';

/** @type {import('./abs')} */
module.exports = Math.abs;



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/abs.js
// module id = 1203
// module chunks = 1